import { useAppSelector } from "../redux/hooks";

export const useUserRole = () => {
    const selectedGroup = useAppSelector((state) => state.selectedGroup.data);
    const role = selectedGroup?.role;

    return {
        isMentor: role === 'mentor',
        isMentee: role === 'mentee',
        isAdmin: role === 'admin',
        role, // optional if you need the role string directly
    };
};
